import React from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { closeSidebar } from 'reducers/sidebarNav-slice';

import { StringModifier, modifyString } from 'constants/copyHelpers';
import { isMobileView } from 'constants/isMobileView';

import { ListItemLeftNav } from 'uiToolkitV1/ListItemLeftNav';

const NavButton = ({ name, icon = null, selected, onClick }) => {
  // const { id, name, type, icon } = cohort ?? {};
  const { moduleName } = useOrganisationSettings();
  const dispatch = useDispatch();
  const onCohortClick = () => {
    if (isMobileView()) {
      onClick();
      dispatch(closeSidebar());
    } else {
      onClick();
    }
  };

  return (
    <ListItemLeftNav
      // key={id + type}
      LeftIconComponent={icon}
      mb={1}
      onClick={onCohortClick}
      title={name === 'My Goals' ? `My ${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)}` : name}
      active={selected}
      showTitleTooltip
    />
  );
};

export { NavButton };
